import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { t } from "@/lib/i18n";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-6 sm:p-12">
      <div className="w-full max-w-md fade-up" data-testid="forgot-password-page">
        <p className="eyebrow">{t("Forgot password")}</p>
        <h1 className="font-serif text-4xl mt-2 text-[#1C201F] leading-tight">{t("Reset your password.")}</h1>
        <p className="text-sm text-[#5C6661] mt-3">
          {t("Enter your account email and we’ll send you a link to choose a new password. The link expires in 1 hour.")}
        </p>
        {sent ? (
          <div className="mt-8 text-sm text-[#2F524A] bg-[#F4F7F6] border border-[#E8ECEA] rounded-lg px-4 py-3"
            data-testid="forgot-password-success">
            {sent}
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-8 space-y-4">
            <div>
              <label className="eyebrow block mb-2" htmlFor="forgot-email">{t("Email")}</label>
              <input id="forgot-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="input-field"
                placeholder={t("you@example.com")} autoComplete="email" data-testid="forgot-password-email" />
            </div>
            {error && (
              <div className="text-sm text-[#9B2C2C] bg-[#FCEDED] border border-[#F5C2C2] rounded-lg px-3 py-2"
                data-testid="forgot-password-error">{error}</div>
            )}
            <button type="submit" disabled={loading} className="btn-primary w-full !rounded-xl"
              data-testid="forgot-password-submit">
              {loading ? t("Sending…") : t("Send reset link")}
            </button>
          </form>
        )}
        <p className="mt-6 text-sm text-[#5C6661]">
          {t("Remembered it?")}{" "}
          <Link to="/login" className="text-[#2F524A] font-semibold hover:underline" data-testid="forgot-password-back">
            {t("Back to log in")}
          </Link>
        </p>
      </div>
    </section>
  );
}
